const countryAustraliaOnly: { [key: string]: string } = {
  AU: 'Australia',
};

export default countryAustraliaOnly;
